import React, { createContext, useContext } from 'react';
import {usePersistedStateSessionStorage} from './persistedStateSessionStorage'

type SessionContextType = {
    session: any;
    setSession: (value: object) => void;
    updatePropSession: (param:{prop:string, value: any}) => void
  }

const defaultSessionStatus = {
    loggedIn: false,
    userName: '',
    token: '',
    pass: '',
    stayLogged: false
}

const SessionContext = createContext<SessionContextType | undefined>(
    undefined
);

type PropTypes = {
    children: React.ReactNode
};
export const SessionProvider = ({children}: PropTypes) => {

    const {state: session, setState: setSession}= usePersistedStateSessionStorage({key: 'session', defaultValue: defaultSessionStatus});
    
    const updatePropSession = (param:{prop:string, value: any}) => {
      const sessionData = {...session}
      sessionData[param.prop] = param.value
      setSession(sessionData)
    }

    return (
        <SessionContext.Provider value={{session, setSession, updatePropSession}}>
            {children}
        </SessionContext.Provider>
      )
}

export function useSession() {
    const context = useContext(SessionContext);
  
    if (!context) {
      throw new Error('"useSession" must be used within IssuesContext')
    }
  
    return context;
  }